const templates = {
  createATemplate: 'Create a Template',
  noTemplatesToDisplay: 'No templates to display',
  template: 'Template',
  templates: 'Templates',
};

export default templates;
